module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"DeleteDates":"Cancella le date non disponibili","formNutritionistUnavailableDates":{"StartDate":"Data inizio","EndDate":"Data fine"}}}')
  delete Component.options._Ctor
}
